<div class="border mt-4">
    <h4>Transporte Maritimo</h4>
    <mat-grid-list cols="2" rowHeight="100px" height="400px">
        <mat-grid-tile>
            <mat-form-field appearance="fill" [formGroup]="FormMaritimo">
                <mat-label>Selecciona transporte maritimo</mat-label>
                <mat-select name="Transporte" formControlName="Transporte"
                    (selectionChange)="changeTipoTransporte($event.value)">  
                        <mat-option *ngFor="let tipo of tipoTransporte" [value]="tipo?.id">
                            {{tipo?.attributes?.matricula}}
                        </mat-option>
                    <mat-option [value]="0">+ Nuevo transporte marítimo</mat-option>
                </mat-select>

            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile>
            <button class="fuse-mat-button-rounded mgbutton" mat-flat-button
                [disabled]="(this.FormMaritimo.value.Transporte <= 0)" (click)="deleteTipoMaritimo()">Eliminar</button>
            <button class="fuse-mat-button-rounded mgbutton" mat-flat-button [color]="'primary'"
                [disabled]="(this.FormMaritimo.invalid)" (click)="saveOrUpdateTipoMaritimo()">Guardar</button>
        </mat-grid-tile>
    </mat-grid-list>

    <div class="row">
        <div class="col-sm-6">
            <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMaritimo">
                <mat-label>PermSCT</mat-label>
                <mat-select name="PermSCT" formControlName="PermSCT">
                    <mat-option *ngFor="let cat of catPermSCT" [value]="cat?.id">
                        {{cat?.attributes?.clave}} - {{cat?.attributes?.nombre}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="(FormMaritimo.get('PermSCT').invalid && FormMaritimo.get('PermSCT').touched)">
                    Campo requerido
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-md-6">
            <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMaritimo">
                <mat-label>TipoEmbarcacion</mat-label>
                <mat-select name="TipoEmbarcacion" formControlName="TipoEmbarcacion">
                    <mat-option *ngFor="let tip of catTipoEmbarcacion" [value]="tip?.id">
                        {{tip?.attributes?.clave}} - {{tip.attributes?.tipo}}
                    </mat-option>
                </mat-select>
                <mat-error
                    *ngIf="(FormMaritimo.get('TipoEmbarcacion').invalid && FormMaritimo.get('UnidadesDeArqBruto').touched)">
                    Campo requerido
                </mat-error>
            </mat-form-field>
        </div>

        <div class="col-sm-3">
            <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMaritimo">
                <mat-label>NumPermisoSCT</mat-label>
                <input name="NumPermisoSCT" maxlength="50" matInput formControlName="NumPermisoSCT">
            </mat-form-field>
        </div>

        <div class="col-sm-3">
            <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMaritimo">
                <mat-label>NombreAseg</mat-label>
                <input name="NombreAseg" matInput maxlength="100" formControlName="NombreAseg">
            </mat-form-field>
        </div>

        <div class="col-sm-3">
            <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMaritimo">
                <mat-label>NumPolizaSeguro</mat-label>
                <input name="NumPolizaSeguro" maxlength="50" matInput formControlName="NumPolizaSeguro">
            </mat-form-field>
        </div>

        <div class="col-sm-3">
            <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMaritimo">
                <mat-label>Matricula</mat-label>
                <input required name="Matricula" minlength="3" maxlength="50" matInput formControlName="Matricula">
                <mat-error *ngIf="(FormMaritimo.get('Matricula').invalid && FormMaritimo.get('Matricula').touched)">
                    Campo requerido
                </mat-error>
            </mat-form-field>
        </div>

        <div class="col-sm-3">
            <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMaritimo">
                <mat-label>NumeroOMI</mat-label>
                <input required name="NumeroOMI" minlength="3" maxlength="50" matInput formControlName="NumeroOMI">
                <mat-error *ngIf="(FormMaritimo.get('NumeroOMI').invalid && FormMaritimo.get('NumeroOMI').touched)">
                    Campo requerido
                </mat-error>
            </mat-form-field>
        </div>

        <div class="col-sm-3">
            <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMaritimo">
                <mat-label>AnioEmbarcacion</mat-label>
                <input type="text" minlength="4" maxlength="4" name="AnioEmbarcacion" matInput
                    formControlName="AnioEmbarcacion">
                <mat-error *ngIf="(f['AnioEmbarcacion'].errors?.['pattern'] && FormMaritimo.get('AnioEmbarcacion').touched)">
                    Ingrese un valo válido
                </mat-error>
            </mat-form-field>
        </div>

        <div class="col-sm-3">
            <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMaritimo">
                <mat-label>NombreEmbarc</mat-label>
                <input name="NombreEmbarc" maxlength="50" matInput formControlName="NombreEmbarc">
            </mat-form-field>
        </div>

        <div class="col-sm-3">
            <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMaritimo">
                <mat-label>NacionalidadEmbarc</mat-label>
                <input type="text" name="NacionalidadEmbarc" placeholder="buscar pais" aria-label="Number" matInput
                    formControlName="NacionalidadEmbarc" [matAutocomplete]="autoNacionalidad">
                <mat-autocomplete autoActiveFirstOption #autoNacionalidad="matAutocomplete"
                    [displayWith]="displayFnNacionalidad" (optionSelected)="changePais($event.option.value.id)">
                    <mat-option *ngFor="let nac of filteredNacionalidad | async" [value]="nac">
                        {{nac?.attributes?.idPais}}-{{ nac?.attributes?.nombre}}
                    </mat-option>
                </mat-autocomplete>
                <mat-error
                    *ngIf="(FormMaritimo.get('NacionalidadEmbarc').invalid && FormMaritimo.get('NacionalidadEmbarc').touched)">
                    Campo requerido
                </mat-error>
            </mat-form-field>
        </div>

        <div class="col-sm-3">
            <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMaritimo">
                <mat-label>UnidadesDeArqBruto</mat-label>
                <input required minlength="1" maxlength="50" name="UnidadesDeArqBruto" matInput
                    formControlName="UnidadesDeArqBruto">
                <mat-error
                    *ngIf="(FormMaritimo.get('UnidadesDeArqBruto').invalid && FormMaritimo.get('UnidadesDeArqBruto').touched)">
                    Campo requerido
                </mat-error>
            </mat-form-field>
        </div>

        <div class="col-md-3">
            <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMaritimo">
                <mat-label>TipoCarga</mat-label>
                <mat-select name="TipoCarga" formControlName="TipoCarga">
                    <mat-option *ngFor="let tc of catTipoCarga" [value]="tc?.id">
                        {{tc?.attributes?.clave}} - {{tc.attributes?.tipo}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="(FormMaritimo.get('TipoCarga').invalid && FormMaritimo.get('TipoCarga').touched)">
                    Campo requerido
                </mat-error>
            </mat-form-field>
        </div>

        <div class="col-sm-3">
            <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMaritimo">
                <mat-label>NumCertITC</mat-label>
                <input required name="NumCertITC" minlength="1" maxlength="50" matInput formControlName="NumCertITC">
                <mat-error *ngIf="(FormMaritimo.get('NumCertITC').invalid && FormMaritimo.get('NumCertITC').touched)">
                    Campo requerido
                </mat-error>
            </mat-form-field>
        </div>

        <div class="col-sm-3">
            <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMaritimo">
                <mat-label>Eslora</mat-label>
                <input name="Eslora" maxlength="50" matInput formControlName="Eslora">
            </mat-form-field>
        </div>

        <div class="col-sm-3">
            <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMaritimo">
                <mat-label>Manga</mat-label>
                <input name="Manga" maxlength="50" matInput formControlName="Manga">
            </mat-form-field>
        </div>

        <div class="col-sm-3">
            <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMaritimo">
                <mat-label>Calado</mat-label>
                <input name="Calado" maxlength="50" matInput formControlName="Calado">
            </mat-form-field>
        </div>

        <div class="col-sm-3">
            <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMaritimo">
                <mat-label>LineaNaviera</mat-label>
                <input name="LineaNaviera" maxlength="50" matInput formControlName="LineaNaviera">
            </mat-form-field>
        </div>

        <div class="col-sm-3">
            <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMaritimo">
                <mat-label>NombreAgenteNaviero</mat-label>
                <input required name="NombreAgenteNaviero" minlength="5" maxlength="60" matInput
                    formControlName="NombreAgenteNaviero">
                <mat-error
                    *ngIf="(FormMaritimo.get('NombreAgenteNaviero').invalid && FormMaritimo.get('NombreAgenteNaviero').touched)">
                    Campo requerido
                </mat-error>
            </mat-form-field>
        </div>

        <div class="col-sm-3">
            <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMaritimo">
                <mat-label>NumAutorizacionNaviero</mat-label>
                <mat-select name="NumAutorizacionNaviero" formControlName="NumAutorizacionNaviero">
                    <mat-option *ngFor="let aut of catAutoNaviero" [value]="aut?.id">
                        {{aut?.attributes?.noAutorizacion}}
                    </mat-option>
                </mat-select>
                <mat-error
                    *ngIf="(FormMaritimo.get('NumAutorizacionNaviero').invalid && FormMaritimo.get('NumAutorizacionNaviero').touched)">
                    Campo requerido
                </mat-error>
            </mat-form-field>
        </div>

        <div class="col-sm-3">
            <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMaritimo">
                <mat-label>NumViaje</mat-label>
                <input name="NumViaje" maxlength="50" matInput formControlName="NumViaje">
            </mat-form-field>
        </div>

        <div class="col-sm-3">
            <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormMaritimo">
                <mat-label>NumConocEmbarc</mat-label>
                <input name="NumConocEmbarc" maxlength="50" matInput formControlName="NumConocEmbarc">

            </mat-form-field>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-1">&nbsp;</div>
        <div class="col-sm-11">
            <h5>Contenedor</h5>
        </div>
        <div class="col-sm-1">&nbsp;</div>
        <div class="col-sm-11">
            <div class="row justify-content-start align-items-center barraGestorPagos mt-4">
                <div class="col-sm-12 col-md-1 col-xl-1">
                    <button (click)="addContenedor()" mat-flat-button color="primary">
                        <mat-icon svgIcon="heroicons_outline:plus-sm"></mat-icon>
                    </button>
                </div>
                <div class="col-sm-12 col-md-1 col-xl-1">
                    <button (click)="removeContenedor()" [disabled]="removeDisabledContenedor" mat-flat-button
                        color="warn">
                        <mat-icon svgIcon="heroicons_outline:minus-sm"></mat-icon>
                    </button>
                </div>
            </div>
        </div>
        <div class="col-sm-1">&nbsp;</div>
        <div class="col-sm-11">
            <app-contenedor-maritimo *ngFor="let con of countContenedor" [contenedor]="con"
                [catalogo]="catContenedores"></app-contenedor-maritimo>
            <hr>
        </div>
    </div>
</div>